import React from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import { Form } from 'react-bootstrap';

const CheckboxFilter = ({
  name,
  setFilter,
  column,
  filters,
  customOptions,
  defaultValue,
  withCaption = false,
  className,
}) => {
  const initialValues = filters.find(filter => filter.id === column)?.value || defaultValue || [];
  const [selectedValues, setSelectedValues] = React.useState(
    Array.isArray(initialValues) ? initialValues : [],
  );

  const handleCheckboxChange = (value, isChecked) => {
    let updatedValues = [...selectedValues];
    if (isChecked) {
      updatedValues = [...updatedValues, value];
    } else {
      updatedValues = updatedValues.filter(val => val !== value);
    }
    setSelectedValues(updatedValues);
    setFilter(column, updatedValues.length ? updatedValues : defaultValue || undefined);
  };

  return (
    <Form.Group
      style={{ minWidth: '150px' }}
      className={`d-flex flex-column align-items-center justify-content-center ${className}`}
    >
      {withCaption && <Form.Label style={{ textTransform: 'capitalize' }}>{name}</Form.Label>}
      {customOptions.map(option => (
        <Form.Check
          key={option.value}
          type="checkbox"
          label={option.label}
          checked={selectedValues.includes(option.value) || option.defaultChecked}
          onChange={e => handleCheckboxChange(option.value, e.target.checked)}
        />
      ))}
    </Form.Group>
  );
};

CheckboxFilter.propTypes = {
  name: PropTypes.string,
  filters: arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.any,
    }),
  ).isRequired,
  setFilter: PropTypes.func.isRequired,
  column: PropTypes.string.isRequired,
  customOptions: arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      defaultChecked: PropTypes.bool,
    }),
  ).isRequired,
  defaultValue: PropTypes.any,
  withCaption: PropTypes.bool,
  className: PropTypes.string,
};

export default CheckboxFilter;
